import { defineAsyncComponent } from 'vue'

export const ModalNativeIosGoogleSignIn = defineAsyncComponent(
    () => import('../ModalNativeIosGoogleSignIn/ModalNativeIosGoogleSignIn.vue'),
)
